(function () {
  if (window.__shippingCalculatorInit) return;
  window.__shippingCalculatorInit = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  function money(value) {
    try {
      return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(value);
    } catch (e) {
      return "R$ " + value.toFixed(2).replace(".", ",");
    }
  }

  function formatCep(cep) {
    return cep.replace(/^(\d{5})(\d{3})$/, "$1-$2");
  }

  function formatDeliveryDays(days) {
    if (!days || !days.length) return "";
    var last = days[days.length - 1];
    return last === 1 ? "1 dia útil" : last + " dias úteis";
  }

  function escapeHtml(str) {
    return String(str == null ? "" : str).replace(/[&<>"']/g, function (ch) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[ch];
    });
  }

  function getJSON(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().then(function (data) {
        return { ok: response.ok, status: response.status, data: data };
      });
    });
  }

  function setup(root) {
    if (root.dataset.shippingCalcReady === "true") return;
    root.dataset.shippingCalcReady = "true";

    var input = root.querySelector("[data-shipping-calc-input]");
    var button = root.querySelector("[data-shipping-calc-button]");
    var notice = root.querySelector("[data-shipping-calc-notice]");
    var result = root.querySelector("[data-shipping-calc-result]");

    if (!input || !button || !notice || !result) return;

    input.addEventListener("input", function (event) {
      var digits = event.target.value.replace(/\D/g, "").slice(0, 8);
      event.target.value = digits.length > 5 ? digits.slice(0, 5) + "-" + digits.slice(5) : digits;
    });

    input.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        button.click();
      }
    });

    button.addEventListener("click", function () {
      run();
    });

    function setLoading(isLoading) {
      button.disabled = isLoading;
      button.textContent = isLoading
        ? button.dataset.loadingText || "Calculando..."
        : button.dataset.text || "Calcular";
    }

    function showError(message) {
      result.hidden = true;
      result.innerHTML = "";
      notice.hidden = false;
      notice.textContent = message;
    }

    function showRates(cep, rates) {
      notice.hidden = true;
      notice.textContent = "";

      var rows = rates
        .map(function (rate) {
          var price = parseFloat(rate.price);
          var isFree = !price || price === 0;
          var eta = formatDeliveryDays(rate.delivery_days);

          return (
            '<div class="m-shipping-calc__rate">' +
            '<div class="m-shipping-calc__rate-info">' +
            '<div class="m-shipping-calc__rate-name">' +
            escapeHtml(rate.name) +
            "</div>" +
            (eta ? '<div class="m-shipping-calc__rate-eta">' + eta + "</div>" : "") +
            "</div>" +
            '<div class="m-shipping-calc__rate-price' +
            (isFree ? " m-shipping-calc__rate-price--free" : "") +
            '">' +
            (isFree ? "Grátis" : money(price)) +
            "</div>" +
            "</div>"
          );
        })
        .join("");

      result.innerHTML =
        '<div class="m-shipping-calc__summary">' +
        "<span>Entregas para o CEP: <strong>" +
        formatCep(cep) +
        "</strong></span>" +
        '<button type="button" class="m-shipping-calc__change">Alterar CEP</button>' +
        "</div>" +
        '<div class="m-shipping-calc__list">' +
        rows +
        "</div>";
      result.hidden = false;

      var changeButton = result.querySelector(".m-shipping-calc__change");
      if (changeButton) {
        changeButton.addEventListener("click", function () {
          input.focus();
          input.select();
        });
      }
    }

    /* Busca UF no ViaCEP (a Shopify precisa da província para cotar). */
    function lookupProvince(cep) {
      return fetch("https://viacep.com.br/ws/" + cep + "/json/")
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (data) {
          if (!data || data.erro) return null;
          return data.uf || null;
        })
        .catch(function () {
          return null;
        });
    }

    function getCart() {
      return getJSON(ROOT + "cart.js", { headers: { Accept: "application/json" } }).then(function (res) {
        return res.ok ? res.data : null;
      });
    }

    /* Adiciona a variante atual só para a Shopify conseguir cotar o frete. */
    function addTemporaryItem() {
      var form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return Promise.resolve(null);

      var formData = new FormData(form);
      if (!formData.get("id")) return Promise.resolve(null);

      return getJSON(ROOT + "cart/add.js", {
        method: "POST",
        headers: { "X-Requested-With": "XMLHttpRequest" },
        body: formData,
      }).then(function (res) {
        return res.ok ? res.data : null;
      });
    }

    /*
      Devolve o carrinho ao estado anterior removendo APENAS o item temporário.
      Nunca use /cart/clear.js aqui: isso apagaria os itens que o cliente já tinha.
    */
    function restoreCart(cartBefore, addedItem) {
      if (!addedItem || !addedItem.key) return Promise.resolve();

      var previous = null;
      if (cartBefore && cartBefore.items) {
        previous = cartBefore.items.filter(function (item) {
          return item.key === addedItem.key;
        })[0];
      }

      return fetch(ROOT + "cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify({ id: addedItem.key, quantity: previous ? previous.quantity : 0 }),
      }).catch(function () {});
    }

    function fetchRates(cep, province) {
      var url =
        ROOT +
        "cart/shipping_rates.json?shipping_address[zip]=" +
        encodeURIComponent(cep) +
        "&shipping_address[country]=BR&shipping_address[province]=" +
        encodeURIComponent(province);

      return getJSON(url, { headers: { Accept: "application/json" } });
    }

    function run() {
      var cep = input.value.replace(/\D/g, "");

      if (cep.length !== 8) {
        showError("Digite um CEP válido, com 8 números.");
        return;
      }

      setLoading(true);

      var cartBefore = null;
      var addedItem = null;

      lookupProvince(cep)
        .then(function (province) {
          if (!province) {
            showError("CEP não encontrado. Confira e tente novamente.");
            return null;
          }

          return getCart().then(function (cart) {
            cartBefore = cart;
            return addTemporaryItem().then(function (item) {
              addedItem = item;
              if (!item) {
                showError("Selecione as opções do produto antes de calcular o frete.");
                return null;
              }
              return fetchRates(cep, province);
            });
          });
        })
        .then(function (res) {
          if (!res) return;

          if (!res.ok || !res.data || !res.data.shipping_rates) {
            showError("Não encontramos opções de frete para este CEP.");
            return;
          }

          if (!res.data.shipping_rates.length) {
            showError("Não encontramos opções de frete para este CEP.");
            return;
          }

          showRates(cep, res.data.shipping_rates);
        })
        .catch(function (error) {
          console.error(error);
          showError("Não foi possível calcular o frete agora. Tente novamente em instantes.");
        })
        .then(function () {
          return restoreCart(cartBefore, addedItem);
        })
        .then(function () {
          setLoading(false);
        });
    }
  }

  function init() {
    var roots = document.querySelectorAll("[data-shipping-calculator]");
    Array.prototype.forEach.call(roots, setup);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
